import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Question, QuestionAnswer, QuestionInstructionLocation } from './../../../../interfaces/question';

@Component({
  selector: 'question-simple-text',
  template: `
    <div class="simple-text-question-container" *ngIf="this.question !== undefined && this.question.type === 'text'">
      <input type="text" [placeholder]="this.placeHolder" [(ngModel)]="this.value" (keyup)="onInput()">
    </div>
  `,
  styleUrls: ['./simple-text-question.component.scss'],
})
export class SimpleTextQuestionComponent implements OnInit {

  @Input() question: Question | undefined;
  @Output() answered = new EventEmitter<QuestionAnswer>();
  value = '';
  placeHolder = '';

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.question !== undefined && Array.isArray(this.question.instructions)) {
      this.question.instructions.forEach((inst) => {
        if (inst.location === QuestionInstructionLocation.PLACEHOLDER) {
          this.placeHolder = inst.content;
        }
      });
    }
  }

  onInput(): void {
    if (this.question === undefined) {
      return;
    }
    this.answered.emit({
      value: this.value,
      questionAnswerSet: [{
        question: this.question,
        metaRelations: []
      }]
    })
  }
}
